import React, { Component } from 'react';
import { connect } from 'react-redux';
import { upgradePositiveMemberSoft, closeAccount } from '../modules/membership_actions';
import { openUpgradeFlowModal } from '../modules/active_modal';
import HowMembershipWorks from './HowMembershipWorks.jsx';
import { navigate } from '../modules/high_level_actions';

class MembershipDetails extends Component {

constructor(props) {
    super(props);
    this.state = {
      isShowing: false
    };
    this.toggleShowingState = this.toggleShowingState.bind(this);
  }

  toggleShowingState() {
    this.setState({isShowing: !this.state.isShowing});
  }

  render() {

    let oMembershipView  = '';
    let iCredits         = '';
    let fCreditPrice     = '';
    let {dispatch}       = this.props;

    // Ensure we have props available to draw data from.
    if( ( this.props.customer ) && ( this.props.customer.credit_total ) && ( this.props.customer.current_cycle.credit_price ) ){
      iCredits     = this.props.customer.credit_total;
      fCreditPrice = this.props.customer.current_cycle.credit_price;
    }

    // Check if Credit Terms have been accepted
    if(this.props.customer.fulfillment_type !== "Negative"){
      let oUpgradeMembershipLink = (<a className="button btn-primary fat full-width" onClick={() => dispatch( openUpgradeFlowModal() )}>Upgrade Your Membership</a>);
      if ( this.props.customer.fulfillment_type === 'Positive' )
        oUpgradeMembershipLink = (<a className="button btn-primary fat full-width" onClick={() => dispatch( upgradePositiveMemberSoft() )}>Upgrade Your Membership</a>);
      if( this.props.storeType === "Negative Option" ) oUpgradeMembershipLink = <div />

      oMembershipView =(
        <div>
          <h4>Upgrade Your Membership</h4>
          {/*<p>
            Upgrade and each month you will have a chance to purchase two Member Credits for ${this.props.one_credit} each,
            which can be used to purchase any title.
          </p>*/}
          <HowMembershipWorks />
          {oUpgradeMembershipLink}
          <button  className="btn-tertiary full-width" onClick={this.toggleShowingState}>Cancel my membership</button>
          <div className={"modal-wrapper" + (this.state.isShowing ? " showing" : "")}>
            <div className="modal-window">
            <div className="modal-close" onClick={this.toggleShowingState}>&times;</div>
              <h3>How to cancel your membership</h3>
              <p>
                We’re sorry that you have decided to cancel your membership.
                <br/>
                Please press the button to confirm your account closure <button className="btn-secondary" onClick={() => dispatch(closeAccount())}>Cancel My Account</button>
                <br/>
                or contact Member Services at {this.props.member_services_phone} and someone will gladly assist you.
              </p>
            </div>
          </div>
        </div>
        );
    }else{
      oMembershipView =(
        <div>
          { this.props.storeType === "Neglite" ? <h5 className="highlight-color">Member Credits: {iCredits}</h5> : <div /> }
          <HowMembershipWorks />
          <button  className="btn-tertiary full-width" onClick={this.toggleShowingState}>Cancel my membership</button>
          <div className={"modal-wrapper" + (this.state.isShowing ? " showing" : "")}>
            <div className="modal-window">
            <div className="modal-close" onClick={this.toggleShowingState}>&times;</div>
              <h3>How to cancel your membership</h3>
              <p>
                We’re sorry that you have decided to cancel your membership.
                <br/>
                Please press the button to confirm your account closure <button className="btn-secondary" onClick={() => dispatch(closeAccount())}>Cancel My Account</button>
                <br/>
                or contact Member Services at {this.props.member_services_phone} and someone will gladly assist you.
              </p>
            </div>
          </div>
        </div>
    );
  }

    return (
      <div>
       <h4 className="alt">Your Membership</h4>
        {oMembershipView}
      </div>
    );
  }
};

function mapStateToProps(state){
    return {
      'member_services_phone': state.store.member_services_phone,
      'customer': state.customer,
      'one_credit': state.store.one_credit,
      'upgradeStatus': state.upgradeStatus,
      'paymentMethods': state.paymentMethods,
      'storeType' : state.store.type
    };
}

export default connect(mapStateToProps)(MembershipDetails);


// WEBPACK FOOTER //
// ./src/components/MembershipDetails.jsx